// TODO: Move thsse into a singular shared component thats used between 
//  the EmailEditor and SignatureRequestEditor if possible.

import { SignatureRequest, WorkflowUser } from "./interface";

function formatSenderDisplay(name: string, email: string): string {
  if (name && email) return `${name} <${email}>`;
  return name || email;
}

export function formatWorkflowUserSender(user?: WorkflowUser): string {
  if (!user) return "";
  return formatSenderDisplay(user.fullName?.trim() || "", user.email?.trim() || "");
}

export function formatSignatureRequestSender(request: SignatureRequest): string {
  const aliasName = request.senderAlias?.aliasName?.trim() || "";
  const aliasEmail = request.senderAlias?.aliasEmail?.trim() || "";
  if (aliasName || aliasEmail)
    return formatSenderDisplay(aliasName, aliasEmail);
  return formatWorkflowUserSender(request.sender);
}

export const EMAIL_PREVIEW_HEADER_CLASS = "flex flex-col gap-0.5 px-4 pt-2 pb-0.5 shrink-0";

export const EMAIL_PREVIEW_LABEL_CLASS = "text-xs text-gray-400 w-14 shrink-0";

export const EMAIL_PREVIEW_FIELD_ROW_CLASS = "flex items-center gap-2";

export function emailPreviewFieldClass(readOnly: boolean): string {
  const base = "flex-1 min-w-0 text-sm border rounded-lg px-2.5 py-1 focus:outline-none";
  if (readOnly)
    return `${base} cursor-default bg-gray-50 text-gray-500 border-gray-100`;
  return `${base} text-gray-700 border-gray-200 focus:border-blue`;
}

export const EMAIL_PREVIEW_BODY_OUTER_CLASS = "flex-1 flex flex-col min-h-0 px-4 pt-1 pb-1";

export function emailPreviewBodyFrameClass(readOnly: boolean): string {
  return `flex-1 min-h-0 flex flex-col border rounded-lg overflow-hidden ${readOnly
    ? "bg-gray-50 border-gray-100"
    : "border-gray-200 focus-within:border-blue"}`;
}

export const EMAIL_PREVIEW_BODY_CONTENT_CLASS = "flex-1 min-h-0 overflow-y-auto px-3 py-2 text-sm text-gray-500 cursor-default";

export const EMAIL_PREVIEW_BODY_CONTENT_EDITABLE_CLASS = "flex-1 min-h-0 overflow-y-auto px-3 py-2 text-sm text-gray-700";

export const AI_PREVIEW_SHELL_ENTER_CLASS = "suggestion-shell-enter";

export const AI_PREVIEW_OUTER_CLASS = "flex flex-col h-full overflow-hidden rounded portant-ai-gradient-window";

export const AI_PREVIEW_LABEL_CLASS = "text-xs text-[#1875FB] w-14 shrink-0";

export function aiPreviewFieldClass(): string {
  return "w-full min-w-0 text-sm px-2.5 py-1 focus:outline-none cursor-default text-gray-700 bg-transparent border-0";
}

export function aiPreviewBodyFrameClass(): string {
  return "flex-1 min-h-0 flex flex-col rounded-lg overflow-hidden portant-ai-field-surface";
}

export const AI_PREVIEW_BODY_CONTENT_CLASS = "flex-1 min-h-0 overflow-y-auto px-3 py-2 text-sm text-gray-700";
